import type { AvatarData } from '@/api/gen/_model/avatarData';
import { TextAvatar } from '@/shared/components';
import type { ClassroomBackgroundRef } from '@/shared/features/classroom/utils/classroomAvatarColor';
import { getClassroomAvatarColor, getDefaultClassroomBackgroundRef } from '@/shared/features/classroom/utils/classroomAvatarColor';
import { UserAvatar } from '@/shared/features/user-avatar';
export function ClassroomAvatarPair({
  classroomId,
  classroomName,
  ownerAvatarData,
  background
}: {
  classroomId?: string;
  classroomName: string;
  ownerAvatarData?: AvatarData;
  background?: ClassroomBackgroundRef | null;
}) {
  // 상세 히어로와 같은 색이어야 해서 같은 규칙(저장 배경 → 학급 id 기본값)으로 고른다.
  const {
    avatarColor,
    avatarTextColor
  } = getClassroomAvatarColor(background ?? getDefaultClassroomBackgroundRef(classroomId ?? classroomName));
  return <div className="flex items-center" data-sentry-component="ClassroomAvatarPair" data-sentry-source-file="ClassroomAvatarPair.tsx">
      <TextAvatar text={classroomName} className="z-[1] border border-[rgba(28,27,31,0.04)] ring-4 ring-white" style={{
      backgroundColor: avatarColor,
      color: avatarTextColor
    }} data-sentry-element="TextAvatar" data-sentry-source-file="ClassroomAvatarPair.tsx" />
      <UserAvatar avatarData={ownerAvatarData} useSprite spritePixelSize={40} className="-ml-2 bg-violet-50" data-sentry-element="UserAvatar" data-sentry-source-file="ClassroomAvatarPair.tsx" />
    </div>;
}